import { render, staticRenderFns } from "./mes.vue?vue&type=template&id=96547252&scoped=true&"
import script from "./mes.vue?vue&type=script&lang=js&"
export * from "./mes.vue?vue&type=script&lang=js&"
import style0 from "./mes.vue?vue&type=style&index=0&id=96547252&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96547252",
  null
  
)

export default component.exports